import axios from "axios";
import {API_URL} from "../config";
import {GET_ERROR_USERS_WEB_RTC, GET_USERS_WEB_RTC} from "../types/types";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {getConsultationMuteId, getMuteId} from "../actions/actionsWebRTC";

export interface ReportCriticalErrorPayload {
    code: string;
}

const LOG_ALERT_URL = `${API_URL}LogAlerts/LogAlert`;

const pendingErrorReports: ReportCriticalErrorPayload[] = [];

function sendOneReport(
    payload: ReportCriticalErrorPayload,
    jwtToken: any,
    onResponse?: (responseText: string) => void
): Promise<void> {
    return axios
        .post(LOG_ALERT_URL, JSON.stringify(payload.code), {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
        .then((response) => {
            const responseText =
                typeof response?.data === "string"
                    ? response.data
                    : response?.data != null
                      ? JSON.stringify(response.data)
                      : "";
            onResponse?.(responseText);
        })
        .catch(() => {
            pendingErrorReports.push(payload);
        });
}

export function reportCriticalError(payload: ReportCriticalErrorPayload, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        if (!jwtToken) {
            pendingErrorReports.push(payload);
            return;
        }
        sendOneReport(payload, jwtToken);
    };
}

const PENDING_REASON = "queued_offline";

export function flushPendingErrorReports(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        if (!jwtToken || pendingErrorReports.length === 0) return;
        const toSend = [...pendingErrorReports];
        pendingErrorReports.length = 0;
        toSend.forEach((payload) => {
            const codeWithMeta =
                payload.code +
                "\npendingErrorReports: true" +
                "\nreason: " +
                PENDING_REASON;
            const payloadWithMeta: ReportCriticalErrorPayload = { code: codeWithMeta };
            sendOneReport(payloadWithMeta, jwtToken, (responseText) => {
                const codeWithResponse =
                    codeWithMeta + "\nresponseText: " + (responseText || "");
                dispatch(
                    reportCriticalError(
                        { code: codeWithResponse },
                        jwtToken
                    )
                );
            });
        });
    };
}

export function getUsersWebRTC(searchValue: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.get(`${API_URL}UserResource/SearchUsersAndQueues?search=${searchValue}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {

                let arraySearch: any = [];

                let users = response.data?.users;
                let queues = response.data?.queues;

                if (users) arraySearch.push(...users);
                if (queues) arraySearch.push(...queues);
                dispatch({type: GET_USERS_WEB_RTC, payload: arraySearch})

            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: GET_ERROR_USERS_WEB_RTC, payload: true});
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function sendCallEvents(type: string, data: any, jwtToken: any, isConsultation?: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}VoipUsers/ReadEvent?eventType=${type}`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
        })
            .then((response) => {
                if (isConsultation) {
                    dispatch(getConsultationMuteId(response.data));
                } else {
                    dispatch(getMuteId(response.data));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch(getMuteId(0));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}
